import { Alert } from "@smart/itops-sb-design-system-dom";

import { useBannersVisibility } from "../../hooks";
import { getUITranslation } from "../../utils";

type AutofillFailureBannerProps = {
  autoFillFailed: boolean;
  selectedLanguage?: string;
};

export const AutofillFailureBanner = ({
  autoFillFailed,
  selectedLanguage,
}: AutofillFailureBannerProps) => {
  const bannersVisibility = useBannersVisibility();

  // visibility only turns off via close, never back on
  // section navigation remounts this, dismissed must stay dismissed
  return (
    autoFillFailed &&
    bannersVisibility &&
    bannersVisibility.visibility.AUTOFILL_FAILED && (
      <Alert
        palette="destructive"
        content={getUITranslation("autofillFailedMessage", selectedLanguage)}
        onClose={() => bannersVisibility.close("AUTOFILL_FAILED")}
      />
    )
  );
};
